import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getBackgroundColorByTimeOfDay } from '../../helpers/EntriesHelper';
import '../css/flowentry_detail.css';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import SwipeableFlows from '../bigPicture/SwipeableFlows';
import SwipeableFlowsContainer from '../bigPicture/SwipeableFlowsContainer';

function FlowDetailsPage(props) {
    const location = useLocation();
    const history = useHistory();

    const [pageBackground, setPageBackground] = useState();
    const [fromView, setFromView] = useState();
    const [flowIndex, setFlowIndex] = useState(0);

    if (!location.state) {
        throw (`Flow details not found in ${location}`);
    }

    useEffect(() => {
        if (!location.state) {
            console.error(`Flow details not found.`);
            return;
        }

        const initialFlowIndex = location.state.flows?.findIndex(flow => location.state.id === flow.entry._id)
        setFlowIndex(initialFlowIndex > -1 ? initialFlowIndex : 0);
        setFromView(location.state.view);

    }, [location])

    useEffect(() => {
        setPageBackground({
            background: getBackgroundColorByTimeOfDay(props.timeOfDay)
        });
    }, [props.timeOfDay])

    const handleChangeIndex = (index) => {
        setFlowIndex(index);
    }

    const handlePrevClick = () => {
        history.goBack();
    }

    return (
        <div className='checkin-details-page' style={pageBackground}>
            <SwipeableFlowsContainer>
                <SwipeableFlows
                    flows={location.state.flows}
                    handleChangeIndex={handleChangeIndex}
                    index={flowIndex}
                    animateHeight={true}
                    swipeHintStyle={{ color: "white", fontSize: "12px", marginRight: "1rem" }}
                />
            </SwipeableFlowsContainer>
            <div className='checkin-details-back-btn-div'>
                <button className="back-to-cal-btn" onClick={handlePrevClick}>
                    {fromView === 'W' ? 'Back to week' : 'Back to month'}
                </button>
            </div>
        </div >
    )
}

export default FlowDetailsPage;